import { defaultLeaveOf } from '@/constant/hr/leave-rule-catalog';
import { LeaveCategoryOption, MyLeaveAllotment } from '../types/leave.types';

/**
 * The leave types the employee may request: the categories their current HR term marks applicable (legacy
 * `myallocations`), named as the category is called today, the term's default leave first and the rest in
 * the term's own order. A category no longer in the organization is left out: the workflow would refuse it.
 */
export const leaveTypeOptionsOf = (
  allotments: MyLeaveAllotment[],
  categories: LeaveCategoryOption[],
  employmentType?: string
): LeaveCategoryOption[] => {
  const titleById = new Map(categories.map((category) => [category.ItemId, category.Title]));
  const applicable = allotments.filter(
    (allotment, index) =>
      allotment.IsApplicable &&
      titleById.has(allotment.LeaveCategoryId) &&
      allotments.findIndex((other) => other.LeaveCategoryId === allotment.LeaveCategoryId) === index
  );
  const defaultLeave = defaultLeaveOf(applicable, employmentType);
  const ordered = defaultLeave
    ? [defaultLeave, ...applicable.filter((allotment) => allotment !== defaultLeave)]
    : applicable;
  return ordered.map((allotment) => ({
    ItemId: allotment.LeaveCategoryId,
    Title: titleById.get(allotment.LeaveCategoryId) || allotment.LeaveCategory,
  }));
};
